import type { ReactNode } from 'react';
import { useState } from 'react';

import {
  AccordionBody,
  AccordionChevron,
  AccordionSection,
  AccordionToggle
} from '../styles/briefPanel.styles';

type PanelAccordionProps = {
  title: string;
  defaultExpanded?: boolean;
  children: ReactNode;
};

const PanelAccordion = ({ title, defaultExpanded = false, children }: PanelAccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const collapsed = !isExpanded;
  const bodyId = `panel-accordion-${title.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <AccordionSection>
      <AccordionToggle
        type="button"
        onClick={() => setIsExpanded(prev => !prev)}
        aria-expanded={isExpanded}
        aria-controls={bodyId}
      >
        <span>{title}</span>
        <AccordionChevron collapsed={collapsed}>&#9660;</AccordionChevron>
      </AccordionToggle>
      <AccordionBody id={bodyId} collapsed={collapsed}>
        {children}
      </AccordionBody>
    </AccordionSection>
  );
};

export default PanelAccordion;
